import LogisticsCreateView from '../../../../../components/Logistics/LogisticsCreateView';

const LogisticsCreate = () => {
  return <LogisticsCreateView />;
};

export default LogisticsCreate;
